<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1400px"
      :title="disabled ? '详情' : form.pkid ? '编辑模板' : '新建模板'"
      @close="$reset('form')">
    <div v-loading="loading" class="template-add-page">
      <div class="form-container">
        <el-form
            ref="form"
            :disabled="disabled"
            :model="form"
            label-width="120px"
            :rules="ruleValidate">
          <el-row>
            <el-col :span="8">
              <el-form-item label="模板名称" prop="templateName">
                <el-input v-model="form.templateName" placeholder="请输入模板名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联客户" prop="customerName">
                <el-input v-model="form.customerName" readonly placeholder="请选择" clearable>
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="$refs.selectCustomer.open()">
                    选择
                  </el-button>
                </el-input>
                <customer-select ref="selectCustomer" @select="selectCustomer"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产品名称" prop="materialID">
                <el-input v-model="form.materialName" readonly placeholder="请选择" clearable>
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="$refs.selectProduct.open()">
                    选择
                  </el-button>
                </el-input>
                <product-select ref="selectProduct" @select="selectProduct"/>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 产品属性 -->
          <div v-if="form.materialID" class="product-properties">
            <h4>产品属性</h4>
            <product-property 
                ref="productProperty" 
                :configure-read-only="!disabled"
                :product-list="form.detailVOList"
                :disabled="disabled"
                @UpdateProductForm="updateProductForm"/>
          </div>
        </el-form>
      </div>
    </div>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="saveTemplate">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import ProductProperty from "@/views/main/components/ProductProperty.vue";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import ProductSelect from "@/views/main/components/ProductSelect.vue";
  
  export default {
    name: "TemplateAdd",
    components: { ProductProperty, CustomerSelect, ProductSelect },
    data() {
      return {
        loading: false,
        isEdit: false,
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        form: {
          pKID: "",
          templateName: "",
          materialName: "",
          materialNO: "",
          materialID: "",
          customerName: "",
          customerID: "",
          detailVOList: [],
        },
        productList: [],
        productProperties: [],
        ruleValidate: {
          templateName: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
          materialID: [{ required: true, message: "请选择产品名称", trigger: "change" }],
          customerName: [{ required: true, message: "请选择客户", trigger: "change" }],
        },
      };
    },
    methods: {
      open(row, isView = false) {
        this.disabled = isView;
        this.dialogVisible = true;
        this.getProductList();
        if (row) {
          this.isEdit = true;
          this.form.pKID = row.pkid;
          this.getData();
        } else {
          this.isEdit = false;
        }
      },
      getData() {
        this.$http.get("basic", `sdProductTemplates/${this.form.pKID}`).then(res => {
          const { data } = res || {};
          this.form = data;
        });
      },
      // 获取产品列表
      getProductList() {
        return this.$http.get("basic", "materials/getPageList", { sellType: 20 }).then(res => {
          this.productList = res.records || [];
        });
      },
      // 产品变更时获取属性
      handleProductChange(materialId) {
        // 添加时间戳参数，避免缓存
        return this.$http.get("basic", `materials/vo1/${materialId}`).then(res => {
          const { data } = res || {};
          this.handleData(data, "materialPropertyVOES");
          if (this.$refs.productProperty) {
            this.$refs.productProperty.freshFormData(this.form.detailVOList);
          }
        });
      },
      // 选择客户
      selectCustomer(row) {
        this.form.customerName = row.customerName;
        this.form.customerID = row.customerID;
      },
      // 选择产品
      selectProduct(row) {
        this.form.materialName = row.materialName;
        this.form.materialNO = row.materialNO;
        this.form.materialID = row.materialID;
        // 触发产品变更事件，获取产品属性
        this.handleProductChange(row.materialID);
      },
      handleData(data, detailKey) {
        // 设置产品基本信息
        const { [detailKey]: details, ...rest } = data || {};
        this.form = { ...this.form, ...rest };
        // 创建新的details数组，避免修改原始data对象
        this.form.detailVOList = (details || []).map(item => {
          const newItem = { ...item };
          // 处理多选类型的默认值，将逗号分隔的字符串转成数组
          if (Number(newItem.valueType) === 1 && typeof newItem.propertyValue === "string") {
            newItem.propertyValue = newItem.propertyValue.split(",").filter(Boolean);
          }
          return newItem;
        });
      },
      updateProductForm(newForm) {
        this.form.detailVOList = newForm;
      },
      handleQuery() {
        // 将产品添加到购物车列表
        this.$refs.productProperty.updateProductForm();
        const newQuery = {
          ...this.form,
          detailVOList: this.form.detailVOList.map(item => ({
            ...item,
            propertyValue: item.valueType === 1 && Array.isArray(item.propertyValue) ? item.propertyValue.join(",") : item.propertyValue,
          })),
        };
        return newQuery;
      },
      // 保存模板
      saveTemplate() {
        this.$refs.form.validate((formValid) => {
          if (formValid) {
            this.$refs.productProperty.getRef().validate((valid) => {
              if (valid) {
                this.submitLoading = true;
                const query = this.handleQuery();
                this.$http.post("basic", "sdProductTemplates", query).then(res => {
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }).finally(() => {
                  this.submitLoading = false;
                });
              }
            }); 
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.template-add-page {

  .page-header {
    margin-bottom: 20px;

    h2 {
      font-size: 20px;
      color: #303133;
      margin: 0;
    }
  }

  .form-container {
    background-color: #fff;
    border-radius: 4px;
  }

  .product-properties {
    h4 {
      margin: 0 0 15px 0;
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }
  }

  .form-actions {
    margin-top: 20px;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
}
</style>